'use client';

import type { AerodromeAdapter } from '../../data/mock-adapters';
import { AdapterPanelShell, Stat, StatGrid } from './AdapterPanelShell';

/**
 * Aerodrome adapter panel.
 *
 * Aerodrome routes AERO emissions via gauges weighted by veAERO votes.
 * The panel exposes the gauge weight + veBoost multiplier so users see
 * how aggressively the pool is incentivised this epoch.
 */
export function AerodromeAdapterPanel({ adapter }: { adapter: AerodromeAdapter }) {
  return (
    <AdapterPanelShell
      adapter={{ ...adapter, label: adapter.label ?? `Aerodrome · ${adapter.pair}` }}
    >
      <StatGrid>
        <Stat label="Gauge wt" value={adapter.gaugeWeightPct} />
        <Stat label="APR" value={adapter.apr} positive />
        <Stat label="TVL" value={adapter.tvlUsd} />
        <Stat label="veBoost" value={adapter.veBoostMultiplier ?? '—'} />
        <Stat label="Pair" value={adapter.pair} />
        <Stat label="Accrued" value={adapter.accrued} hint={adapter.accruedUsd} />
      </StatGrid>
    </AdapterPanelShell>
  );
}
